import React, { useEffect } from 'react'
import { Cookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { login } from 'store/actions';
import { DISABILITY } from '../constants';

export const Start = () => {
  const cookie = new Cookies(document.cookie);
  const decoded = cookie.get("token");
  const securityLvl = cookie.get("securityLevel");
  const isImpaired = cookie.get("cookieImpaired");
  const dispatch = useDispatch();
  const navigate = useNavigate();


  useEffect(()=>{
      localStorage.setItem("token", decoded);
      localStorage.setItem("securityLvl", securityLvl);
      dispatch({
        type:DISABILITY,
        payload:isImpaired
      })
      dispatch(login(() => navigate('/dash')));
  },[]);

  return(
    <>
    </>
  )
}